module.exports = __webpack_public_path__ + "img/Professional-5.c90f9dee.gif";